import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";

import {ProgressBarComponent} from './progress-bar.component';
import {ProgressGaugeComponent} from "./progress-gauge.component";
import { PercentageSingleBarComponent } from './percentage-single-bar/percentage-single-bar.component';

@NgModule({
    imports: [
        CommonModule
    ],
    exports: [
        ProgressBarComponent,
        ProgressGaugeComponent,
        PercentageSingleBarComponent
    ],
    declarations: [
        ProgressBarComponent,
        ProgressGaugeComponent,
        PercentageSingleBarComponent
    ],
    providers: [],
})
export class GraficasModule {
}
